import Query from '../../../components/Report';

export default new Query('search-summary-top-pages');
